export default "__VITE_ASSET__COE_y9jF__"